import React, { useState } from "react";
import "./App.css";

import { auth } from "./firebase/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { SignIn } from "./components/signIn";
import NavbarMy from "./components/navbar";
import CombinedMusicList from "./components/CombinedMusicList";

function App() {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [uploadHandler, setUploadHandler] = useState<(() => void) | null>(null);

  const handleAdminStatusChange = (adminStatus: boolean, onUploadClick: () => void) => {
    setIsAdmin(adminStatus);
    setUploadHandler(() => onUploadClick);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <SignIn />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Background logo */}
      <img 
        src="/logo-bg.svg" 
        alt="" 
        className="fixed inset-0 w-full h-full object-contain opacity-[0.03] blur-sm pointer-events-none z-[-1]"
        style={{ transform: 'scale(1.5)' }}
      />
      
      <header>
        <NavbarMy 
          user={user} 
          isAdmin={isAdmin}
          onUploadClick={uploadHandler || undefined}
        />
      </header>
      
      <main>
        <CombinedMusicList 
          user={user} 
          onAdminStatusChange={handleAdminStatusChange}
        />
      </main>
    </div>
  );
}

export default App;
